import React from 'react';
import styled from 'styled-components';

const HeroContentStyles = styled.div`
  color: #000;
  h1 {
    color: white;
    text-shadow: 2px 2px 3px rgb(0,0,0,0.5);
    font-family: 'Alfa Slab One';
    letter-spacing: 1px;
    @media (max-width: 1200px) {
      font-size: 2.2rem;
    }
    @media (max-width: 992px) {
      font-size: 2rem;
    }
    @media (max-width: 768px) {
      font-size: 2rem;
    }
    @media (max-width: 575px) {
      font-size: 1.35rem;
    }
  }
`;

const HeroContentContainer = ({ children }) => {
  if (!children) return null;
  return (
    <HeroContentStyles>
      <div className="hero-content my-2 mx-1 mx-sm-4 mx-md-6 py-sm-1 py-md-3">
        { children }
      </div>
    </HeroContentStyles>
  );
};

export default HeroContentContainer;
